import { render, staticRenderFns } from "./NameSlug.vue?vue&type=template&id=07589a92&"
import script from "./NameSlug.vue?vue&type=script&lang=js&"
export * from "./NameSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports